export type IQuestionsState = {
  page: number;
  search: Profile;
  results: any;
  response: any;
  filteredResults: number;
  requestSearch: boolean;
  profiles: Profile[];
  filterMenuSearch: number[];
  lastSearch: Partial<Search>;
  reportSelected: string;
  reports: Report[];
  reportLoaded: Record<string, boolean>;
  reports_admin: Report[];
  users_admin: User[];
  apprehension_icons: Icon[];
  transport_icons: Icon[];
  holiday_icons: Icon[];
  factors_icons: Icon[];
  inspiration_icons: Icon[];
  accomodation_icons: Icon[];
  answers: Answers;
  questions: Question[];
  markets: {
    name: string;
    link: string;
    demo: string;
    flag: string;
  }[];
  researchData: {
    multiple: Record<string, unknown>;
    year: number;
    market: Record<string, unknown>;
    demographics: Record<string, unknown>;
    behaviours: Record<string, unknown>;
    factors: Record<string, unknown>;
    catalysts: Record<string, unknown>;
    enablers: Record<string, unknown>;
    barriers: Record<string, unknown>;
    plannings: Record<string, unknown>;
    destinations: Record<string, unknown>;
    audit: Record<string, unknown>;
  };
};

type Report = {
  user_id: string;
  report_id: string;
  year: number;
  type: string;
  markets: number;
  destinations: number;
  factors: number[];
  competitors: number[];
  time_created: string;
  deleted: number;
  id: string;
  market: string;
  demo: string;
  destination: string;
};
type User = {
  user_id: string;
  report_id: string;
  year: number;
  type: string;
  markets: number;
  destinations: number;
  factors: number[];
  competitors: number[];
  time_created: string;
  deleted: number;
  id: string;
  market: string;
  demo: string;
  destination: string;
};

type Icon = {
  name: string;
  icon: string;
};

type Question = {
  order: number;
  question: string;
  type: string;
  icon: boolean;
  answer: Record<string, Answer>;
};

type Answer = {
  text: string;
  icon: string;
};

type Answers = {
  [key: string]: string;
};

export default function (): IQuestionsState {
  return {
    page: 1,
    results: {},
    // @ts-ignore
    search: {},
    filteredResults: 0,
    requestSearch: false,
    profiles: [],
    response: {},
    filterMenuSearch: [
      1, 2, 3, 4, 5, 51, 52, 53, 6, 7, 8, 81, 82, 83, 9, 91, 92, 93
    ],
    lastSearch: {
      multiple: false,
      demographics: {},
      behaviours: {},
      plannings: {},
      factors: {},
      catalysts: {},
      enablers: {},
      barriers: {},
      destinations: {},
      year: undefined
    },
    reportSelected: '9803460',
    reports: [
      {
        user_id: '',
        report_id: 'free',
        year: 2022,
        type: 'BRAND_REPORT',
        markets: 8,
        destinations: 58,
        factors: [127, 128, 129, 131, 137],
        competitors: [55, 80, 98, 42],
        time_created: '2021-10-28 14:55:57',
        deleted: 0,
        id: 'free',
        market: 'Spain',
        demo: 'Spanish',
        destination: 'Jordan'
      }
    ],
    reportLoaded: {},
    reports_admin: [],
    users_admin: [],
    apprehension_icons: [
      { name: 'Yes, definitely', icon: 'las la-calendar-check' },
      {
        name: 'Yes, if I myself feel that it is safe',
        icon: 'las la-calendar-plus'
      },
      {
        name: 'Maybe if it is a really good offer',
        icon: 'las la-calendar-day'
      },
      { name: 'No', icon: 'las la-calendar-times' }
    ],
    transport_icons: [
      { name: 'Own vehicle', icon: 'las la-car-side' },
      { name: 'Rental Car', icon: 'las la-car' },
      { name: 'Bus', icon: 'las la-bus' },
      { name: 'Train', icon: 'las la-train' },
      { name: 'Flight first class/business class', icon: 'las la-plane' },
      { name: 'Flight premium economy / economy', icon: 'las la-plane' },
      { name: 'Ferry', icon: 'directions_boat_filled' },
      { name: 'Private boats (small cruices / yatching)', icon: 'sailing' },
      { name: 'Cruise', icon: 'las la-ship' }
    ],
    holiday_icons: [
      {
        name: 'Camping (caravan, autocamper, mobile home, tent)',
        icon: 'las la-shuttle-van'
      },
      { name: 'Glamping (luxury camping)', icon: 'las la-campground' },
      {
        name: 'Holiday home (not your own privately owned home)',
        icon: 'las la-home'
      },
      {
        name: 'Private rental (e.g. Airbnb, Homeaway, house swap)',
        icon: 'lab la-airbnb'
      },
      {
        name: 'My own private home at the destination',
        icon: 'las la-house-damage'
      },
      { name: 'Bed and Breakfast', icon: 'las la-bed' },
      { name: 'Budget hotel/hostel', icon: 'las la-h-square' },
      { name: 'Farmhouse', icon: 'las la-dog' },
      { name: 'Traditional/historic property', icon: 'las la-landmark' },
      { name: 'Independent 3-4* hotel', icon: 'las la-hotel' },
      { name: 'Boutique hotel', icon: 'las la-map-pin' },
      { name: 'City hotel', icon: 'las la-concierge-bell' },
      { name: 'Globally recognised hotel brand', icon: 'las la-star' },
      { name: 'Resort', icon: 'las la-umbrella-beach' },
      { name: 'Luxury hotel (5+*)', icon: 'las la-wallet' },
      { name: 'Spahotel', icon: 'las la-spa' },
      {
        name: 'Contemporary style accommodation/design hotel',
        icon: 'las la-igloo'
      },
      { name: 'Staying with friends or family', icon: 'las la-user-friends' },
      { name: 'Other', icon: 'more_horiz' },
      { name: 'Hotel/resort', icon: 'las la-hotel' },
      { name: 'Vacation home', icon: 'las la-umbrella-beach' },
      { name: 'Cruise', icon: 'las la-ship' },
      {
        name: 'Charter/package trips with all inclusive',
        icon: 'card_membership'
      },
      {
        name: 'Charter/package trips without all inclusive',
        icon: 'credit_card'
      },
      {
        name: 'Roadtrip (where driving around and visiting places is the central part of the trip)',
        icon: 'las la-car-alt'
      },
      {
        name: 'Drive yourself (where you drive to one or more destinations in Europe)',
        icon: 'las la-car-side'
      },
      { name: 'Private rental (e.g. Airbnb)', icon: 'las la-home' },
      { name: 'Round trip', icon: 'las la-redo-alt' },
      { name: 'Hostel', icon: 'las la-h-square' },
      { name: 'Camping', icon: 'las la-campground' },
      { name: 'Group travel (min. 8 pax)', icon: 'las la-users' },
      { name: 'Skiing', icon: 'las la-skiing' },
      { name: 'Do not know', icon: 'las la-asterisk' },

      { name: 'Sun and beach holiday', icon: 'las la-umbrella-beach' },
      { name: 'Skiing holiday', icon: 'las la-skiing' },
      {
        name: 'Cultural holiday (where historical and cultural experiences are the main purpose)',
        icon: 'las la-landmark'
      },
      {
        name: 'Round trip (multiple locations/destinations in one holiday)',
        icon: 'las la-redo-alt'
      },
      { name: 'Group holiday (min. 8 pax)', icon: 'las la-users' },
      { name: 'Big city holiday', icon: 'las la-city' },
      { name: 'Religious holiday', icon: 'las la-praying-hands' },
      {
        name: 'Special occations travel, eg. Stag or hen trip, anniversary or birthday celebration',
        icon: 'las la-birthday-cake'
      },
      {
        name: 'Active holiday (hiking, sport, surfing, climbing ect.)',
        icon: 'las la-hiking'
      },
      {
        name: 'Volunteering as part of the holiday',
        icon: 'las la-hands-helping'
      },
      {
        name: 'Doing my hobby (golf, birdwatching, hunting, diving)',
        icon: 'las la-golf-ball'
      },
      { name: 'Wedding or honeymoon', icon: 'las la-ring' },
      {
        name: 'Visiting/experiencing festivals, events, sports events',
        icon: 'las la-laugh-beam'
      },
      { name: 'Visiting friends and family', icon: 'las la-people-carry' },
      {
        name: 'Getting culinary experiences (food, wine, whiskey, beer)',
        icon: 'las la-beer'
      },
      {
        name: 'Relaxing (unwind, getting into a lower gear)',
        icon: 'las la-bed'
      },
      {
        name: 'Doing something good for myself (wellness, retreat, yoga, spa)',
        icon: 'las la-spa'
      },
      { name: 'Meeting new people', icon: 'las la-user-friends' },

      { name: 'Cruise holiday', icon: 'las la-ship' },
      {
        name: 'Multi destination tour (multiple locations/destinations in one holiday)',
        icon: 'las la-redo-alt'
      },
      {
        name: 'Religious (Pilgrimage, practice religion)',
        icon: 'las la-praying-hands'
      },
      {
        name: 'Special occation travel, eg. Stag or hen party, anniversary or birthday celebration',
        icon: 'las la-birthday-cake'
      },
      {
        name: 'Other Active holiday (hiking, sport, surfing, climbing, riding ect.)',
        icon: 'las la-hiking'
      },
      { name: 'Birdwatching, Safari', icon: 'las la-crow' },
      {
        name: 'Attending festivals, events, sports events',
        icon: 'las la-laugh-beam'
      },
      {
        name: 'Gastronomic/culinary/wine experiences',
        icon: 'las la-wine-bottle'
      },
      { name: 'Golf holiday', icon: 'las la-golf-ball' },
      { name: 'Diving holiday', icon: 'las la-swimming-pool' },
      {
        name: 'Combining business and pleasure (extending business travel)',
        icon: 'las la-briefcase'
      }
    ],
    factors_icons: [
      { name: 'Climate/weather', icon: 'las la-sun' },
      { name: 'Price level in the country', icon: 'las la-hand-holding-usd' },
      { name: 'Sustainability', icon: 'las la-leaf' },
      { name: 'Safety', icon: 'las la-shield-alt' },
      { name: 'Child friendly', icon: 'las la-baby-carriage' },
      { name: 'Environment and cleanliness', icon: 'las la-solar-panel' },
      { name: 'Opportunities for shopping', icon: 'las la-shopping-bag' },
      { name: 'Opportunities for outdoor activities', icon: 'las la-mountain' },
      {
        name: 'Opportunities for cultural events (festival, sports matches, etc.)',
        icon: 'las la-glass-cheers'
      },
      {
        name: 'Opportunities for historic experiences',
        icon: 'las la-landmark'
      },
      { name: 'Opportunities to visit a big city', icon: 'las la-city' },
      {
        name: 'Opportunities to go to the beach',
        icon: 'las la-umbrella-beach'
      },
      { name: 'Opportunities to hobbies (sport, etc.)', icon: 'las la-futbol' },
      { name: 'Wellness / spa options', icon: 'las la-spa' },
      {
        name: 'Opportunities for exciting food experiences',
        icon: 'las la-utensils'
      },
      { name: 'Fine dining', icon: 'las la-concierge-bell' },
      {
        name: 'That the country is visited by relatively few tourists',
        icon: 'las la-circle'
      },
      {
        name: 'Opportunities to visit fairs/rides',
        icon: 'las la-theater-masks'
      },
      { name: 'Fishing / hunting opportunities', icon: 'las la-fish' },
      {
        name: 'That the country is known for good food / good restaurants',
        icon: 'las la-star'
      },
      { name: 'Exciting cities to visit', icon: 'las la-fire-alt' },
      {
        name: 'That the country is visited by many tourists',
        icon: 'las la-users'
      },
      {
        name: 'Price level in the country (affordability)',
        icon: 'las la-hand-holding-usd'
      },
      {
        name: 'Environmental concerns and sustainability',
        icon: 'las la-leaf'
      },
      { name: 'Safety standards/low crime levels', icon: 'las la-shield-alt' },
      { name: 'Child friendliness', icon: 'las la-baby-carriage' },
      { name: 'Cleanliness', icon: 'las la-broom' },
      { name: 'Shopping', icon: 'las la-shopping-bag' },
      { name: 'Nature/outdoor experiences', icon: 'las la-mountain' },
      {
        name: 'Cultural experiences (museums, concerts, theaters)',
        icon: 'las la-theater-masks'
      },
      { name: 'Historical experiences', icon: 'las la-landmark' },
      { name: 'Going to the beach', icon: 'las la-umbrella-beach' },
      {
        name: 'Gaining a new skill/developing skill, e.g. language, cooking or similar',
        icon: 'las la-sign-language'
      },
      { name: 'Wellness/Spa', icon: 'las la-spa' },
      {
        name: 'Exciting food experience opportunities',
        icon: 'las la-utensils'
      },
      { name: 'Food experiences', icon: 'las la-utensils' },
      { name: 'Fine dining', icon: 'las la-concierge-bell' },
      {
        name: 'That the destination has few tourists',
        icon: 'las la-user-alt-slash'
      },
      {
        name: 'Opportunities for going to theme- or amusement parks',
        icon: 'las la-laugh-beam'
      },
      { name: 'Being active', icon: 'las la-running' },
      { name: 'Guided/Arranged tours/experiences', icon: 'las la-users' },
      { name: 'Big city experiences', icon: 'las la-city' },
      { name: 'Getting new experiences', icon: 'las la-fire-alt' },
      { name: 'Meeting new people', icon: 'las la-user-friends' },
      { name: 'Interacting with locals', icon: 'las la-language' },
      {
        name: 'Easy access to health and medical facilities',
        icon: 'las la-ambulance'
      },
      { name: 'Accessibility for less mobile', icon: 'las la-wheelchair' },
      { name: 'LGBTQ+-friendly', icon: 'las la-mercury' },
      { name: 'LGBTQ+-friendly', icon: 'las la-mercury' },
      {
        name: 'Climate compensated/Low carbon emission hotel, flight, bus, train, ect.',
        icon: 'las la-smog'
      },
      { name: 'All inclusive accommodation options', icon: 'las la-wallet' },
      { name: 'Direct flight', icon: 'las la-plane' },
      { name: 'Flights from local airport', icon: 'las la-plane-departure' },
      {
        name: 'Being able to drive to the destination yourself',
        icon: 'las la-truck-pickup'
      },
      { name: 'Being active (Sport, adventure)', icon: 'las la-running' },
      { name: 'Nightlife', icon: 'las la-glass-cheers' },
      { name: 'Photography', icon: 'las la-camera' },
      { name: 'Minimizing my carbon footprint', icon: 'las la-smog' },
      {
        name: 'Opportunities for going to theme parks',
        icon: 'las la-laugh-beam'
      },
      { name: 'Living new experiences', icon: 'las la-fire-alt' },
      {
        name: 'Being able to drive to the destination',
        icon: 'las la-truck-pickup'
      },
      {
        name: 'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
        icon: 'las la-wallet'
      },
      { name: 'Flights from my local airport', icon: 'las la-plane-departure' },
      { name: 'Health and hygiene standards', icon: 'las la-notes-medical' },
      { name: 'Pet friendly', icon: 'las la-dog' }
    ],
    inspiration_icons: [
      { name: 'Friends/acquaintances', icon: 'las la-user-friends' },
      { name: 'Facebook', icon: 'lab la-facebook' },
      { name: 'Instagram', icon: 'lab la-instagram' },
      { name: 'Snapchat', icon: 'lab la-snapchat' },
      { name: 'Twitter', icon: 'lab la-twitter' },
      { name: 'Blogs', icon: 'las la-rss' },
      { name: 'Podcasts', icon: 'las la-podcast' },
      { name: 'TikTok', icon: 'las la-mobile' },
      { name: 'Youtube', icon: 'lab la-youtube' },
      { name: 'Online reviews', icon: 'las la-star-half-alt' },
      { name: 'Print media', icon: 'las la-newspaper' },
      { name: 'Print media ', icon: 'las la-newspaper' },
      { name: 'Online media', icon: 'las la-globe' },
      { name: 'Print brochures', icon: 'las la-sticky-note' },
      { name: 'Print brochures ', icon: 'las la-sticky-note' },
      { name: 'Online brochures', icon: 'las la-wifi' },
      { name: 'Influencers and celebrities', icon: 'las la-camera-retro' },
      { name: 'Cinema/movies', icon: 'las la-film' },
      { name: 'TV advertising', icon: 'las la-ad' },
      { name: 'Travel TV programmes', icon: 'las la-tv' },
      { name: 'TV (flow-TV or on-demand)', icon: 'las la-tv' },
      { name: 'Radio', icon: 'las la-broadcast-tower' },
      { name: 'Search engines (Google, Bing..)', icon: 'lab la-google' },
      { name: 'Travel agency recommendation', icon: 'las la-store-alt' },
      { name: 'Travel company websites', icon: 'las la-passport' },
      { name: 'None of the above', icon: 'las la-asterisk' },
      {
        name: 'Online reviews sites (Tripadvisor, etc.)',
        icon: 'lab la-tripadvisor'
      },
      {
        name: 'Oficial tourism board / office website',
        icon: 'las la-building'
      },
      { name: 'Online Travel Agencies', icon: 'las la-store' },
      {
        name: 'Travel company websites (airline, hotels, etc.)',
        icon: 'las la-plane'
      },
      {
        name: 'Online lifestyle and travel magazines',
        icon: 'las la-book-open'
      },
      { name: 'Twitch', icon: 'lab la-twitch' },
      { name: 'Wechat', icon: 'las la-comment-alt' },
      { name: 'Newspapers and Supplements', icon: 'las la-newspaper' },
      {
        name: 'Lifestyle and travel print magazines',
        icon: 'las la-book-open'
      },
      {
        name: 'Travel agency recommendation / Shop windows',
        icon: 'las la-store'
      },
      { name: 'Promotional Events', icon: 'las la-calendar' },
      { name: 'Outdoor advertising', icon: 'las la-road' },
      { name: 'Family & friends', icon: 'las la-user-friends' },
      { name: 'Cinema/movies', icon: 'las la-film' },
      { name: 'TV advertising', icon: 'las la-ad' },
      { name: 'Travel TV programmes', icon: 'las la-tv' },
      { name: 'TV (flow-TV or on-demand)', icon: 'las la-tv' },
      { name: 'Radio', icon: 'las la-broadcast-tower' },
      { name: 'TV series live', icon: 'las la-tv' },
      {
        name: 'TV series on demand (Netfix, HBO, Disney+, Amazon Prime, etc.)',
        icon: 'las la-tv'
      },
      { name: 'Pinterest', icon: 'lab la-pinterest' }
    ],

    accomodation_icons: [
      {
        name: 'Camping (caravan, autocamper, mobile home, tent)',
        icon: 'las la-shuttle-van'
      },
      { name: 'Glamping (luxury camping)', icon: 'las la-campground' },
      {
        name: 'Holiday home (not your own privately owned home)',
        icon: 'las la-home'
      },
      {
        name: 'Private rental (e.g. Airbnb, Homeaway, house swap)',
        icon: 'lab la-airbnb'
      },
      {
        name: 'My own private home at the destination',
        icon: 'las la-house-damage'
      },
      { name: 'Bed and Breakfast', icon: 'las la-bed' },
      { name: 'Budget hotel/hostel', icon: 'las la-h-square' },
      { name: 'Farmhouse', icon: 'las la-dog' },
      { name: 'Traditional/historic property', icon: 'las la-landmark' },
      { name: 'Independent 3-4* hotel', icon: 'las la-hotel' },
      { name: 'Boutique hotel', icon: 'las la-map-pin' },
      { name: 'City hotel', icon: 'las la-concierge-bell' },
      { name: 'Globally recognised hotel brand', icon: 'las la-star' },
      { name: 'Resort', icon: 'las la-umbrella-beach' },
      { name: 'Luxury hotel (5+*)', icon: 'las la-wallet' },
      { name: 'Spahotel', icon: 'las la-spa' },
      {
        name: 'Contemporary style accommodation/design hotel',
        icon: 'las la-igloo'
      },
      { name: 'Staying with friends or family', icon: 'las la-user-friends' },
      { name: 'Other', icon: 'more_horiz' },
      { name: 'Hotel/resort', icon: 'las la-hotel' },
      { name: 'Vacation home', icon: 'las la-umbrella-beach' },
      { name: 'Cruise', icon: 'las la-ship' },
      {
        name: 'Charter/package trips with all inclusive',
        icon: 'card_membership'
      },
      {
        name: 'Charter/package trips without all inclusive',
        icon: 'credit_card'
      },
      {
        name: 'Roadtrip (where driving around and visiting places is the central part of the trip)',
        icon: 'las la-car-alt'
      },
      {
        name: 'Drive yourself (where you drive to one or more destinations in Europe)',
        icon: 'las la-car-side'
      },
      { name: 'Private rental (e.g. Airbnb)', icon: 'las la-home' },
      { name: 'Round trip', icon: 'las la-redo-alt' },
      { name: 'Hostel', icon: 'las la-h-square' },
      { name: 'Camping', icon: 'las la-campground' },
      { name: 'Group travel (min. 8 pax)', icon: 'las la-users' },
      { name: 'Skiing', icon: 'las la-skiing' },
      { name: 'Do not know', icon: 'las la-asterisk' }
    ],

    // @TODO: solo se usa para los países de la home y de la página de reportes
    markets: [
      {
        name: 'England',
        link: 'uk',
        demo: 'English',
        flag: 'gb'
      },
      {
        name: 'France',
        link: 'france',
        demo: 'French',
        flag: 'fr'
      },
      {
        name: 'Germany',
        link: 'germany',
        demo: 'German',
        flag: 'de'
      },
      {
        name: 'Italy',
        link: 'italy',
        demo: 'Italian',
        flag: 'it'
      },
      {
        name: 'Netherlands',
        link: 'netherlands',
        demo: 'Dutch',
        flag: 'nl'
      },
      {
        name: 'Nordics',
        link: 'norway',
        demo: 'Nordic',
        flag: 'no'
      },
      {
        name: 'Northern Ireland',
        link: 'northireland',
        demo: 'Northern Irish',
        flag: 'england'
      },
      {
        name: 'Scotland',
        link: 'scotland',
        demo: 'Scottish',
        flag: 'scotland'
      },
      {
        name: 'Spain',
        link: 'spain',
        demo: 'Spanish',
        flag: 'es'
      },
      {
        name: 'Wales',
        link: 'wales',
        demo: 'Welsh',
        flag: 'wales'
      },
      {
        name: 'Norway',
        link: 'norway',
        demo: 'Norwegian',
        flag: 'no'
      },
      {
        name: 'Sweden',
        link: 'sweden',
        demo: 'Swedish',
        flag: 'se'
      },
      {
        name: 'Denmark',
        link: 'denmark',
        demo: 'Danish',
        flag: 'dk'
      },
      {
        name: 'Finland',
        link: 'finland',
        demo: 'Finnish',
        flag: 'fi'
      },
      {
        name: 'United Kingdom',
        demo: 'British',
        link: 'uk',
        flag: 'gb'
      },
      {
        name: 'Nordic Countries',
        demo: 'Nordic',
        link: 'nordic',
        flag: 'no'
      },
      {
        name: 'Europe',
        demo: 'European',
        link: 'europe',
        flag: 'eu'
      }
    ],
    answers: {},
    // questions: [
    //   {
    //     order: 1,
    //     question: 'What is your gender?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: { text: 'Male', icon: 'las la-male' },
    //       2: { text: 'Female', icon: 'las la-female' }
    //     }
    //   },
    //   {
    //     order: 2,
    //     question: 'What is your age?',
    //     type: 'fill',
    //     answer: {}
    //   },
    //   {
    //     order: 3,
    //     question: 'In what area do you live?',
    //     type: 'list',
    //     icon: true,
    //     answer: {
    //       1: { text: 'Andalusia', icon: 'las la-map-marker' },
    //       2: { text: 'Aragón', icon: 'las la-map-marker' },
    //       3: { text: 'Principado de Asturias', icon: 'las la-map-marker' },
    //       4: { text: 'Illes Balears', icon: 'las la-map-marker' },
    //       5: { text: 'Canarias', icon: 'las la-map-marker' },
    //       6: { text: 'Cantabria', icon: 'las la-map-marker' },
    //       7: { text: 'Castilla y León', icon: 'las la-map-marker' },
    //       8: { text: 'Castilla-La Mancha', icon: 'las la-map-marker' },
    //       9: { text: 'Cataluña', icon: 'las la-map-marker' },
    //       10: { text: 'Comunitat Valenciana', icon: 'las la-map-marker' },
    //       11: { text: 'Extremadura', icon: 'las la-map-marker' },
    //       12: { text: 'Galicia', icon: 'las la-map-marker' },
    //       13: { text: 'Comunidad de Madrid', icon: 'las la-map-marker' },
    //       14: { text: 'Región de Murcia', icon: 'las la-map-marker' },
    //       15: { text: 'Comunidad Foral de Navarra', icon: 'las la-map-marker' },
    //       16: { text: 'País Vasco', icon: 'las la-map-marker' },
    //       17: { text: 'La Rioja', icon: 'las la-map-marker' },
    //       18: { text: 'Ciudad Autónoma de Ceuta', icon: 'las la-map-marker' },
    //       19: { text: 'Ciudad Autónoma de Melilla', icon: 'las la-map-marker' }
    //     }
    //   },
    //   {
    //     order: 4,
    //     question: 'Are you…?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: { text: 'Single', icon: 'las la-user' },
    //       2: { text: 'Co-habiting / Married', icon: 'las la-user-friends' }
    //     },
    //     none: { val: 3, text: 'Do not want to state' }
    //   },
    //   {
    //     order: 5,
    //     question: 'What age are your children/shared children?',
    //     subtext: 'Multiple choice',
    //     highlight: true,
    //     type: 'single',
    //     answer: {
    //       2: '0-1 years',
    //       3: '2 years',
    //       4: '3 years',
    //       5: '4 years',
    //       6: '5 years',
    //       7: '6 years',
    //       8: '7 years',
    //       9: '8 years',
    //       10: '9 years',
    //       11: '10 years',
    //       12: '11 years',
    //       13: '12 years',
    //       14: '13 years',
    //       15: '14 years',
    //       16: '15 years',
    //       17: '16 years',
    //       18: '17 years',
    //       19: 'Have child / children over 18 living at home'
    //     },
    //     none: {
    //       val: 1,
    //       text: 'Do not have children / only have children who have moved away from home'
    //     }
    //   },
    //   {
    //     order: 6,
    //     question: 'What is your household income per year?',
    //     subtext: 'Before tax',
    //     type: 'slider',
    //     min: 1,
    //     max: 7,
    //     step: 1,
    //     answer: {
    //       1: 'Below 20.000 EUR',
    //       2: '20.000-40.000 EUR',
    //       3: '40.000-65.000 EUR',
    //       4: '65.000-95.000 EUR',
    //       5: '95.000-150.000 EUR',
    //       6: '150.000 EUR or more'
    //     },
    //     none: { val: 7, text: 'Do not know/Do not want to state' }
    //   },
    //   {
    //     order: 7,
    //     question: 'What is your highest ranking completed education?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: { text: 'School', icon: 'las la-school' },
    //       2: { text: 'Vocational education', icon: 'las la-book-reader' },
    //       3: {
    //         text: 'Bachelors degree or similar',
    //         icon: 'las la-graduation-cap'
    //       },
    //       4: {
    //         text: 'Master degree or similar or above',
    //         icon: 'las la-chalkboard-teacher'
    //       }
    //     },
    //     none: { val: 5, text: 'Do not know / Do not want to state' }
    //   },
    //   {
    //     order: 8,
    //     question:
    //       'Tick the category that best suits your experience with and perception of the country as a holiday destination?',
    //     list: 'destinations',
    //     type: 'multibymulti',
    //     answer: [
    //       {
    //         title: 'I have never had a holiday in ',
    //         answers: {
    //           1: 'Never heard of',
    //           2: 'Only a little knowledge',
    //           3: 'Would rather not visit',
    //           4: 'Have a positive impression',
    //           5: 'Would like to visit in the long run',
    //           6: 'Would like to visit within 3 years'
    //         }
    //       },
    //       {
    //         title: 'I have been holidaying in ',
    //         answers: {
    //           7: 'Have visited - bad experience',
    //           8: 'Have visited - positive experience',
    //           9: 'Have visited - would like to visit again'
    //         }
    //       }
    //     ]
    //   },
    //   {
    //     order: 9,
    //     question:
    //       'Thinking about the holidays you expect to go on in the next few years, which of the below do you find fiting for these holidays?',
    //     subtext: 'Multiple choice',
    //     highlight: true,
    //     type: 'list',
    //     icon: true,
    //     answer: {
    //       11: { text: 'Sun and beach holiday', icon: 'light_mode' },
    //       12: { text: 'Skiing holiday', icon: 'downhill_skiing' },
    //       13: {
    //         text: 'Cultural holiday (where historical and cultural experiences are the main purpose)',
    //         icon: 'account_balance'
    //       },
    //       14: { text: 'Cruise', icon: 'directions_boat' },
    //       15: {
    //         text: 'Round trip (multiple locations/destinations in one holiday)',
    //         icon: 'public'
    //       },
    //       16: { text: 'Group holiday (min. 8 pax)', icon: 'groups' },
    //       17: { text: 'Big city holiday', icon: 'location_city' },
    //       18: { text: 'Religious holiday', icon: 'change_history' },
    //       19: {
    //         text: 'Special occations travel, eg. Stag or hen trip, anniversary or birthday celebration',
    //         icon: 'cake'
    //       },
    //       20: {
    //         text: 'Active holiday (hiking, sport, surfing, climbing ect.)',
    //         icon: 'hiking'
    //       },
    //       21: {
    //         text: 'Volunteering as part of the holiday',
    //         icon: 'volunteer_activism'
    //       },
    //       22: {
    //         text: 'Doing my hobby (golf, birdwatching, hunting, diving)',
    //         icon: 'golf_course'
    //       },
    //       23: { text: 'Wedding or honeymoon', icon: 'favorite_border' },
    //       24: {
    //         text: 'Visiting/experiencing festivals, events, sports events',
    //         icon: 'emoji_events'
    //       },
    //       25: { text: 'Visiting friends and family', icon: 'family_restroom' },
    //       26: {
    //         text: 'Getting culinary experiences (food, wine, whiskey, beer)',
    //         icon: 'restaurant'
    //       },
    //       27: {
    //         text: 'Relaxing (unwind, getting into a lower gear)',
    //         icon: 'self_improvement'
    //       },
    //       28: {
    //         text: 'Doing something good for myself (wellness, retreat, yoga, spa)',
    //         icon: 'spa'
    //       },
    //       29: { text: 'Meeting new people', icon: 'emoji_people' },
    //       30: { text: 'Other', icon: 'more_horiz' }
    //     },
    //     none: { val: 31, text: 'Do not know' }
    //   },
    //   {
    //     order: 10,
    //     question: 'What is typically your preferred type of accommodation?',
    //     subtext: 'Multiple choice',
    //     highlight: true,
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       11: {
    //         text: 'Camping (caravan, autocamper, mobile home, tent)',
    //         icon: 'las la-shuttle-van'
    //       },
    //       12: { text: 'Glamping (luxury camping)', icon: 'las la-campground' },
    //       13: {
    //         text: 'Holiday home (not your own privately owned home)',
    //         icon: 'las la-home'
    //       },
    //       14: {
    //         text: 'Private rental (e.g. Airbnb, Homeaway, house swap)',
    //         icon: 'lab la-airbnb'
    //       },
    //       15: {
    //         text: 'My own private home at the destination',
    //         icon: 'las la-house-damage'
    //       },
    //       16: { text: 'Bed and Breakfast', icon: 'las la-bed' },
    //       17: { text: 'Budget hotel/hostel', icon: 'las la-h-square' },
    //       18: { text: 'Farmhouse', icon: 'las la-dog' },
    //       19: {
    //         text: 'Traditional/historic property',
    //         icon: 'las la-landmark'
    //       },
    //       20: { text: 'Independent 3-4* hotel', icon: 'las la-hotel' },
    //       21: { text: 'Boutique hotel', icon: 'las la-map-pin' },
    //       22: { text: 'City hotel', icon: 'las la-concierge-bell' },
    //       23: { text: 'Globally recognised hotel brand', icon: 'las la-star' },
    //       24: { text: 'Resort', icon: 'las la-umbrella-beach' },
    //       25: { text: 'Luxury hotel (5+*)', icon: 'las la-wallet' },
    //       26: { text: 'Spahotel', icon: 'las la-spa' },
    //       27: {
    //         text: 'Contemporary style accommodation/design hotel',
    //         icon: 'las la-igloo'
    //       },
    //       28: {
    //         text: 'Staying with friends or family',
    //         icon: 'las la-user-friends'
    //       },
    //       29: { text: 'Other', icon: 'more_horiz' }
    //     },
    //     none: { val: 30, text: 'Do not know' }
    //   },
    //   {
    //     order: 11,
    //     question:
    //       'To what extent do you value the below, when choosing a holiday destination?',
    //     list: 'preferences',
    //     type: 'multiByList',
    //     answer: {
    //       1: 'Very little importance',
    //       2: 'Little importance',
    //       3: 'Medium',
    //       4: 'Great importance',
    //       5: 'Very important',
    //       6: 'Do not know'
    //     }
    //   },
    //   {
    //     order: 12,
    //     question:
    //       'What has been your average annual household holiday budget for the last 2-3 years? ',
    //     subtext:
    //       'All types of travel, including - transport, accommodation, food, excursions, etc.',
    //     type: 'slider',
    //     min: 1,
    //     max: 11,
    //     step: 1,
    //     answer: {
    //       1: 'Below 1000 EUR',
    //       2: '1000-2999 EUR',
    //       3: '3000-4999 EUR',
    //       4: '5000-9999 EUR',
    //       5: '10000-14999 EUR',
    //       6: '15000-19999 EUR',
    //       7: '20000-24999 EUR',
    //       8: '25000-29999 EUR',
    //       9: '30000-34999 EUR',
    //       10: '35000-39999EUR',
    //       11: '40000 EUR or more'
    //     },
    //     none: { val: 12, text: 'Do not know/Do not want to state' }
    //   },
    //   {
    //     order: 13,
    //     question:
    //       'Compare your above answer with your household holiday budget for 2022?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: {
    //         text: 'Budget will be smaller in 2022',
    //         icon: 'las la-less-than'
    //       },
    //       2: { text: 'Budget will be the same', icon: 'las la-equals' },
    //       3: {
    //         text: 'Budget will be bigger in 2022',
    //         icon: 'las la-greater-than'
    //       }
    //     },
    //     none: { val: 4, text: 'Do not know' }
    //   },
    //   {
    //     order: 14,
    //     question:
    //       'When do you expect to go on short international holidays (up to 4 days) in 2022?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: { text: 'January', icon: 'las la-calendar' },
    //       2: { text: 'February', icon: 'las la-calendar-day' },
    //       3: { text: 'March', icon: 'las la-calendar-week' },
    //       4: { text: 'April', icon: 'las la-calendar' },
    //       5: { text: 'May', icon: 'las la-calendar-day' },
    //       6: { text: 'June', icon: 'las la-calendar-week' },
    //       7: { text: 'July', icon: 'las la-calendar' },
    //       8: { text: 'August', icon: 'las la-calendar-day' },
    //       9: { text: 'September', icon: 'las la-calendar-week' },
    //       10: { text: 'October', icon: 'las la-calendar' },
    //       11: { text: 'November', icon: 'las la-calendar-day' },
    //       12: { text: 'December', icon: 'las la-calendar-week' }
    //     },
    //     none: {
    //       val: 13,
    //       text: 'I do not expect to go on short international holidays in 2022'
    //     }
    //   },
    //   {
    //     order: 15,
    //     question:
    //       'When do you expect to go on long international holidays (5 days or more) in 2022?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: { text: 'January', icon: 'las la-calendar' },
    //       2: { text: 'February', icon: 'las la-calendar-day' },
    //       3: { text: 'March', icon: 'las la-calendar-week' },
    //       4: { text: 'April', icon: 'las la-calendar' },
    //       5: { text: 'May', icon: 'las la-calendar-day' },
    //       6: { text: 'June', icon: 'las la-calendar-week' },
    //       7: { text: 'July', icon: 'las la-calendar' },
    //       8: { text: 'August', icon: 'las la-calendar-day' },
    //       9: { text: 'September', icon: 'las la-calendar-week' },
    //       10: { text: 'October', icon: 'las la-calendar' },
    //       11: { text: 'November', icon: 'las la-calendar-day' },
    //       12: { text: 'December', icon: 'las la-calendar-week' }
    //     },
    //     none: {
    //       val: 13,
    //       text: 'I do not expect to go on long international holidays in 2022'
    //     }
    //   },
    //   {
    //     order: 16,
    //     question:
    //       'When do you expect to go on short domestic holidays (up to 4 days) in 2022?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: { text: 'January', icon: 'las la-calendar' },
    //       2: { text: 'February', icon: 'las la-calendar-day' },
    //       3: { text: 'March', icon: 'las la-calendar-week' },
    //       4: { text: 'April', icon: 'las la-calendar' },
    //       5: { text: 'May', icon: 'las la-calendar-day' },
    //       6: { text: 'June', icon: 'las la-calendar-week' },
    //       7: { text: 'July', icon: 'las la-calendar' },
    //       8: { text: 'August', icon: 'las la-calendar-day' },
    //       9: { text: 'September', icon: 'las la-calendar-week' },
    //       10: { text: 'October', icon: 'las la-calendar' },
    //       11: { text: 'November', icon: 'las la-calendar-day' },
    //       12: { text: 'December', icon: 'las la-calendar-week' }
    //     },
    //     none: {
    //       val: 13,
    //       text: 'I do not expect to go on short domestic holidays in 2022'
    //     }
    //   },
    //   {
    //     order: 17,
    //     question:
    //       'When do you expect to go on long domestic holidays (5 days or more) in 2022?',
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: { text: 'January', icon: 'las la-calendar' },
    //       2: { text: 'February', icon: 'las la-calendar-day' },
    //       3: { text: 'March', icon: 'las la-calendar-week' },
    //       4: { text: 'April', icon: 'las la-calendar' },
    //       5: { text: 'May', icon: 'las la-calendar-day' },
    //       6: { text: 'June', icon: 'las la-calendar-week' },
    //       7: { text: 'July', icon: 'las la-calendar' },
    //       8: { text: 'August', icon: 'las la-calendar-day' },
    //       9: { text: 'September', icon: 'las la-calendar-week' },
    //       10: { text: 'October', icon: 'las la-calendar' },
    //       11: { text: 'November', icon: 'las la-calendar-day' },
    //       12: { text: 'December', icon: 'las la-calendar-week' }
    //     },
    //     none: {
    //       val: 13,
    //       text: 'I do not expect to go on long domestic holidays in 2022'
    //     }
    //   },
    //   {
    //     order: 18,
    //     question:
    //       'Where do you find inspiration when you choose destinations for your holidays?',
    //     subtext: 'Multiple choice',
    //     highlight: true,
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       11: { text: 'Friends/acquaintances', icon: 'las la-user-friends' },
    //       12: { text: 'Facebook', icon: 'lab la-facebook' },
    //       13: { text: 'Instagram', icon: 'lab la-instagram' },
    //       14: { text: 'Snapchat', icon: 'lab la-snapchat' },
    //       15: { text: 'Twitter', icon: 'lab la-twitter' },
    //       16: { text: 'Blogs', icon: 'las la-rss' },
    //       17: { text: 'Podcasts', icon: 'las la-podcast' },
    //       18: { text: 'TikTok', icon: 'las la-mobile' },
    //       19: { text: 'Youtube', icon: 'lab la-youtube' },
    //       20: { text: 'Online reviews', icon: 'las la-star-half-alt' },
    //       21: { text: 'Print media', icon: 'las la-newspaper' },
    //       22: { text: 'Online media', icon: 'las la-globe' },
    //       23: { text: 'Print brochures', icon: 'las la-sticky-note' },
    //       24: { text: 'Online brochures', icon: 'las la-wifi' },
    //       25: {
    //         text: 'Influencers and celebrities',
    //         icon: 'las la-camera-retro'
    //       },
    //       26: { text: 'Cinema/movies', icon: 'las la-film' },
    //       27: { text: 'TV advertising', icon: 'las la-ad' },
    //       28: { text: 'Travel TV programmes', icon: 'las la-tv' },
    //       29: { text: 'Radio', icon: 'las la-broadcast-tower' },
    //       30: {
    //         text: 'Search engines (Google, Bing..)',
    //         icon: 'lab la-google'
    //       },
    //       31: {
    //         text: 'Travel agency recommendation',
    //         icon: 'las la-store-alt'
    //       },
    //       32: { text: 'Travel company websites', icon: 'las la-passport' }
    //     },
    //     none: { val: 33, text: 'None of the above' }
    //   },
    //   {
    //     order: 19,
    //     question: 'Where and how do you expect to book your holidays in 2022?',
    //     subtext: 'Multiple choice',
    //     highlight: true,
    //     type: 'list',
    //     icon: true,
    //     answer: {
    //       1: {
    //         text: 'Book package trip (flight+accommodation) online at travel agency website',
    //         icon: 'las la-laptop'
    //       },
    //       2: {
    //         text: 'Book package trip (flight+accommodation) with a travel agent in person or via phone/email',
    //         icon: 'las la-user-astronaut'
    //       },
    //       3: {
    //         text: 'Book seperate flight and hotel online via different booking portals/travel agencies',
    //         icon: 'las la-tags'
    //       },
    //       4: {
    //         text: 'Book package (flight and accommodation) direct with tour operator',
    //         icon: 'las la-store-alt'
    //       },
    //       5: {
    //         text: 'Book accommodation directly via the accommodations website',
    //         icon: 'las la-hotel'
    //       },
    //       6: {
    //         text: 'Book transportation directly via the airline/car rental/rail/coach/cruise website',
    //         icon: 'las la-car-side'
    //       },
    //       7: {
    //         text: 'Use price comparison site (e.g. Momondo, Trivago, Skyscanner)',
    //         icon: 'las la-exchange-alt'
    //       }
    //     },
    //     none: { val: 8, text: 'None of the above' }
    //   },
    //   {
    //     order: 20,
    //     question:
    //       'Put a mark if you have done the following as part of a private paid holiday in the last 12 months?',
    //     subtext: 'Multiple choice',
    //     highlight: true,
    //     type: 'single',
    //     icon: true,
    //     answer: {
    //       1: {
    //         text: 'Flown first class/business class',
    //         icon: 'las la-credit-card'
    //       },
    //       2: { text: 'Flown premium economy', icon: 'las la-plane-departure' },
    //       3: { text: 'Stayed at a suite/villa', icon: 'las la-umbrella-beach' },
    //       4: {
    //         text: 'Paid extra for butler/maid/chef',
    //         icon: 'las la-concierge-bell'
    //       }
    //     },
    //     none: { val: 5, text: 'None of the above' }
    //   }
    // ],
    preferences: [
      'Price level in the country (affordability)',
      'Environmental concerns and sustainability',
      'Safety standards/low crime levels',
      'Cleanliness',
      'Opportunities for going to theme- or amusement parks',
      'Going to the beach',
      'Shopping',
      'Being active',
      'Wellness/Spa',
      'Nature/outdorr experiences',
      'Cultural experiences (museums, concerts, theathers)',
      'Historical experiences',
      'Guided/Arranged tours/experiences',
      'Big city experiences',
      'Exciting food experience opportunities',
      'Fine dining',
      'Gaining a new skill/developing skill, e.g. language, cooking or similar',
      'Child friendliness',
      'That the destination has few tourists',
      'Getting new experiences',
      'Meeting new people',
      'Interacting with locals',
      'Easy access to health and medical facilities',
      'Accessibilty for less mobile',
      'LGBTQ+-friendly',
      'Climatecompensated/Low carbon emission hotel, flight, bus, train, ect.',
      'All inclusive accommodation options',
      'Direct flight',
      'Flights from local airport',
      'Being able to drive to the destination yourself'
    ],
    factors: [
      { label: 'Price level in the country (affordability)', value: 127 },
      { label: 'Environmental concerns and sustainability', value: 128 },
      { label: 'Safety standards/low crime levels', value: 129 },
      { label: 'Cleanliness', value: 131 },
      { label: 'Opportunities for going to theme parks', value: 143 },
      { label: 'Going to the beach', value: 137 },
      { label: 'Shopping', value: 132 },
      { label: 'Being active (Sport, adventure)', value: 148 },
      { label: 'Wellness/Spa', value: 139 },
      { label: 'Nature/outdoor experiences', value: 133 },
      {
        label: 'Cultural experiences (museums, concerts, theaters)',
        value: 134
      },
      { label: 'Historical experiences', value: 135 },
      { label: 'Guided/Arranged tours/experiences', value: 149 },
      { label: 'Big city experiences', value: 150 },
      { label: 'Exciting food experience opportunities', value: 140 },
      { label: 'Fine dining', value: 141 },
      {
        label:
          'Gaining a new skill/developing skill, e.g. language, cooking or similar',
        value: 138
      },
      { label: 'Child friendliness', value: 130 },
      { label: 'That the destination has few tourists', value: 142 },
      { label: 'Living new experiences', value: 151 },
      { label: 'Meeting new people', value: 152 },
      { label: 'Interacting with locals', value: 153 },
      { label: 'Easy access to health and medical facilities', value: 154 },
      { label: 'Accessibility for less mobile', value: 155 },
      { label: 'LGBTQ+-friendly', value: 156 },
      { label: 'Minimizing my carbon footprint', value: 157 },
      { label: 'All inclusive accommodation options', value: 158 },
      { label: 'Direct flight', value: 159 },
      { label: 'Flights from my local airport', value: 160 },
      { label: 'Being able to drive to the destination', value: 161 },
      { label: 'Health and hygiene standards', value: 162 },
      { label: 'Pet friendly', value: 163 },
      { label: 'Nightlife', value: 164 },
      { label: 'Photography', value: 165 },
      {
        label:
          'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
        value: 166
      }
    ],
    factors2022B: [
      { label: 'Price level in the country (affordability)', value: 127 },
      { label: 'Environmental concerns and sustainability', value: 128 },
      { label: 'Safety standards/low crime levels', value: 129 },
      { label: 'Cleanliness', value: 131 },
      { label: 'Opportunities for going to theme parks', value: 143 },
      { label: 'Going to the beach', value: 137 },
      { label: 'Shopping', value: 132 },
      { label: 'Being active (Sport, adventure)', value: 148 },
      { label: 'Wellness/Spa', value: 139 },
      { label: 'Nature/outdoor experiences', value: 133 },
      { label: 'Guided/Arranged tours/experiences', value: 149 },
      { label: 'Big city experiences', value: 150 },
      { label: 'Exciting food experience opportunities', value: 140 },
      { label: 'Fine dining', value: 141 },
      {
        label:
          'Gaining a new skill/developing skill, e.g. language, cooking or similar',
        value: 138
      },
      { label: 'Child friendliness', value: 130 },
      { label: 'That the destination has few tourists', value: 142 },
      { label: 'Living new experiences', value: 151 },
      { label: 'Meeting new people', value: 152 },
      { label: 'Interacting with locals', value: 153 },
      { label: 'Easy access to health and medical facilities', value: 154 },
      { label: 'Accessibility for less mobile', value: 155 },
      { label: 'LGBTQ+-friendly', value: 156 },
      { label: 'Minimizing my carbon footprint', value: 157 },
      { label: 'All inclusive accommodation options', value: 158 },
      { label: 'Direct flight', value: 159 },
      { label: 'Flights from my local airport', value: 160 },
      { label: 'Being able to drive to the destination', value: 161 },
      { label: 'Health and hygiene standards', value: 162 },
      { label: 'Pet friendly', value: 163 },
      { label: 'Nightlife', value: 164 },
      { label: 'Photography', value: 165 },
      {
        label:
          'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
        value: 166
      },
      {
        label:
          'Cultural & Historical Experiences (Museums, cultural & historical sites)',
        value: 167
      },
      {
        label:
          'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
        value: 168
      },
      { label: 'Agenda of Festivals, Concerts & Events', value: 169 }
    ],
    factors2023: [
      { label: 'Price level in the country (affordability)', value: 127 },
      { label: 'Environmental concerns and sustainability', value: 128 },
      { label: 'Safety standards/low crime levels', value: 129 },
      { label: 'Cleanliness', value: 131 },
      { label: 'Opportunities for going to theme parks', value: 143 },
      { label: 'Going to the beach', value: 137 },
      { label: 'Shopping', value: 132 },
      { label: 'Being active (Sport, adventure)', value: 148 },
      { label: 'Wellness/Spa', value: 139 },
      { label: 'Nature/outdoor experiences', value: 133 },
      { label: 'Guided/Arranged tours/experiences', value: 149 },
      { label: 'Big city experiences', value: 150 },
      { label: 'Food experiences', value: 140 },
      { label: 'Fine dining', value: 141 },
      {
        label:
          'Gaining a new skill/developing skill, e.g. language, cooking or similar',
        value: 138
      },
      { label: 'Child friendliness', value: 130 },
      { label: 'That the destination has few tourists', value: 142 },
      { label: 'Living new experiences', value: 151 },
      { label: 'Meeting new people', value: 152 },
      { label: 'Interacting with locals', value: 153 },
      { label: 'Easy access to health and medical facilities', value: 154 },
      { label: 'Accessibility for less mobile', value: 155 },
      { label: 'LGBTQ+- friendliness', value: 156 },
      { label: 'Minimizing my carbon footprint', value: 157 },
      { label: 'All inclusive accommodation options', value: 158 },
      { label: 'Direct flight', value: 159 },
      { label: 'Flights from my local airport', value: 160 },
      { label: 'Being able to drive to the destination', value: 161 },
      { label: 'Health and hygiene standards', value: 162 },
      { label: 'Pet friendliness', value: 163 },
      { label: 'Nightlife', value: 164 },
      { label: 'Photography', value: 165 },
      {
        label:
          'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
        value: 166
      },
      {
        label:
          'Cultural & Historical Experiences (Museums, cultural & historical sites)',
        value: 167
      },
      {
        label:
          'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
        value: 168
      },
      { label: 'Agenda of Festivals, Concerts & Events', value: 169 },
      { label: 'Backpacker friendliness', value: 170 }
    ],
    factors2023B: [
      { label: 'Price level in the country (affordability)', value: 127 },
      {
        label:
          'Environmental concerns and sustainability (travel activity impact/carbon footprint/etc.)',
        value: 128
      },
      { label: 'Safety standards/low crime levels', value: 129 },
      { label: 'Child friendliness', value: 130 },
      {
        label: 'General cleanliness (garbage management standards)',
        value: 131
      },
      { label: 'Shopping', value: 132 },
      { label: 'Nature/outdoor experiences', value: 133 },
      { label: 'Going to the beach', value: 137 },
      {
        label:
          'Gaining a new skill/developing skill, e.g. language, cooking or similar',
        value: 138
      },
      { label: 'Wellness/Spa', value: 139 },
      { label: 'Food experiences', value: 140 },
      { label: 'Fine dining', value: 141 },
      { label: 'That the destination has few tourists', value: 142 },
      { label: 'Opportunities for going to theme parks', value: 143 },
      { label: 'Being active (Sport, adventure)', value: 148 },
      {
        label:
          'Discovering the destination though guided or arranged tours/experiences',
        value: 149
      },
      { label: 'Big city experiences', value: 150 },
      {
        label: 'Living new experiences (getting out of the confort zone)',
        value: 151
      },
      { label: 'Opportunity for meeting new people', value: 152 },
      { label: 'Interacting with locals', value: 153 },
      {
        label:
          'Easy access to medical facilities (infrastructure, availability, proximity).',
        value: 154
      },
      { label: 'Accessibility for travellers with less mobility', value: 155 },
      { label: 'LGBTQ+- friendliness', value: 156 },
      { label: 'All inclusive accommodation options', value: 158 },
      { label: 'Direct flight', value: 159 },
      { label: 'Flights from my local airport', value: 160 },
      { label: 'Being able to drive to the destination', value: 161 },
      {
        label:
          'Health and hygiene standards associated to local / global outbreaks',
        value: 162
      },
      { label: 'Pet friendliness', value: 163 },
      { label: 'Nightlife', value: 164 },
      {
        label: 'Opportunity to pursue travel / artistic photography',
        value: 165
      },
      {
        label:
          'Availability of luxury and VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
        value: 166
      },
      {
        label:
          'Cultural & Historical Experiences (Museums, cultural & historical sites)',
        value: 167
      },
      {
        label:
          'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
        value: 168
      },
      { label: 'Agenda of Festivals, Concerts & Events', value: 169 },
      { label: 'Backpacker friendliness', value: 170 },
      {
        label:
          'Possibility of a spiritual experience, pilgrimage or practice religion',
        value: 180
      },
      {
        label:
          'The possibility to practice a specific preferred activity as ski, diving, surf, kitesurf, golf, etc.',
        value: 181
      },
      { label: 'Opportunities to make social media content', value: 182 },
      { label: 'Premium/luxury accommodation options', value: 183 },
      { label: 'Going to the mountain and wilderness', value: 184 },
      { label: 'Visiting small and unique towns', value: 185 }
    ],
    destinations: {
      Europe: [
        'Albania',
        'Andorra',
        'Austria',
        'Belgium',
        'Bosnia-Herzegovina',
        'Bulgaria',
        'Croatia',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'England',
        'Estonia',
        'Faroe Islands',
        'Finland',
        'France',
        'Georgia',
        'Germany',
        'Greece',
        'Greenland',
        'Hungary',
        'Iceland',
        'Ireland',
        'Italy',
        'Latvia',
        'Lithuania',
        'Luxembourg',
        'Malta',
        'Montenegro',
        'Monaco',
        'Netherlands',
        'Macedonia',
        'Northern Ireland',
        'Norway',
        'Poland',
        'Portugal',
        'Romania',
        'Russia',
        'Scotland',
        'Serbia',
        'Slovakia',
        'Slovenia',
        'Spain',
        'San Marino',
        'Sweden',
        'Switzerland',
        'United Kingdom',
        'Wales',
        'St Marino'
      ],
      Africa: [
        'Cabo Verde',
        'Botswana',
        'Gambia',
        'Kenya',
        'Madagascar',
        'Malawi',
        'Mauritius',
        'Namibia',
        'Rwanda',
        'Seychelles',
        'South Africa',
        'Senegal',
        'Tansania',
        'Tanzania',
        'Tunisia',
        'Morocco',
        'Zambia',
        'Zimbabwe'
      ],
      'Asia & Oceania': [
        'Australia',
        'Burma',
        'Cambodia',
        'China',
        'Hong Kong',
        'India',
        'Indonesia',
        'Japan',
        'Laos',
        'Malaysia',
        'Maldives',
        'Nepal',
        'New Zealand',
        'Philippines',
        'Singapore',
        'South Korea',
        'Sri Lanka',
        'Taiwan',
        'Thailand',
        'Vietnam',
        'Fiji',
        'Phillipines',
        'United Arab Emirates',
        'Myanmar (Burma)',
        'Azerbaiyán'
      ],
      'Middle East': [
        'Abu Dhabi',
        'Armenia',
        'Azerbaijan',
        'Bahrain',
        'Dubai',
        'Egypt',
        'Israel',
        'Jordan',
        'Oman',
        'Pakistan',
        'Qatar',
        'Saudi Arabia',
        'Turkey'
      ],
      America: [
        'Antigua and Barbuda',
        'Argentina',
        'Aruba',
        'Aspen',
        'Barbados',
        'Belize',
        'Bahamas',
        'Bolivia',
        'Brazil',
        'Canada',
        'Chile',
        'Colombia',
        'Mexico',
        'Costa Rica',
        'Cuba',
        'Ecuador',
        'Guatemala',
        'Guyana French',
        'Honduras',
        'Jamaica',
        'Martinique',
        'Panama',
        'Paraguay',
        'Peru',
        'Puerto Rico',
        'Saint Lucia',
        'Saint Vincent and the Grenadines',
        'Suriname',
        'St Lucia',
        'The Dominican Republic',
        'Tahiti',
        'The Dominican Rep.',
        'Trinidad and Tobago',
        'United States of America',
        'Uruguay',
        'Venezuela',
        'Virgin Islands'
      ],
      'Other destinations': [
        'Balearic Islands',
        'Canary Islands',
        'California',
        'Fort Myers',
        'Florida',
        'Guernsey',
        'Jersey',
        'Guadeloupe',
        'Ile de la Reunion',
        'Andalusia',
        'Granada',
        'Malaga',
        'Sevilla',
        'Macau',
        'Ras Al Khaimah',
        'Sharjah',
        'Las Vegas',
        'Tenerife',
        'Curacao',
        'Tarragona',
        'Costa Brava',
        'Girona',
        'Barcelona',
        'Catalonia',
        'Madeira',
        'Quebec',
        'Miami',
        'New York',
        'Guyana',
        'French Guiana',
        'New Caledonia',
        'Cadiz',
        'Gran Canaria',
        'Lanzarote',
        'Costa del Sol',
        'Costa del Sol - Malaga',
        'Fuerteventura',
        'Madrid',
        'Valencia',
        'Washington',
        'New Orleans',
        'Nevada',
        'Arizona',
        'Philladelphia',
        'Lousiana',
        'La Réunion (France)',
        'Tahiti / French Polynesia (France)',
        'New Caledonia (France)',
        'New South Wales - AUS',
        'Los Cabos',
        'Grenada (Caribbean Islands)',
        'Pittsburgh',
        'Greater Palm Springs'
      ]
    },
    factorsIcons: [
      { name: 'Climate/weather', icon: 'las la-sun' },
      { name: 'Price level in the country', icon: 'las la-hand-holding-usd' },
      { name: 'Sustainability', icon: 'las la-leaf' },
      { name: 'Safety', icon: 'las la-shield-alt' },
      { name: 'Child friendly', icon: 'las la-baby-carriage' },
      { name: 'Environment and cleanliness', icon: 'las la-solar-panel' },
      { name: 'Opportunities for shopping', icon: 'las la-shopping-bag' },
      { name: 'Opportunities for outdoor activities', icon: 'las la-mountain' },
      {
        name: 'Opportunities for cultural events (festival, sports matches, etc.)',
        icon: 'las la-glass-cheers'
      },
      {
        name: 'Opportunities for historic experiences',
        icon: 'las la-landmark'
      },
      { name: 'Opportunities to visit a big city', icon: 'las la-city' },
      {
        name: 'Opportunities to go to the beach',
        icon: 'las la-umbrella-beach'
      },
      { name: 'Opportunities to hobbies (sport, etc.)', icon: 'las la-futbol' },
      { name: 'Wellness / spa options', icon: 'las la-spa' },
      {
        name: 'Opportunities for exciting food experiences',
        icon: 'las la-fish'
      },
      { name: 'Fine dining', icon: 'las la-concierge-bell' },
      {
        name: 'That the country is visited by relatively few tourists',
        icon: 'las la-circle'
      },
      {
        name: 'Opportunities to visit fairs/rides',
        icon: 'las la-theater-masks'
      },
      { name: 'Fishing / hunting opportunities', icon: 'las la-fish' },
      {
        name: 'That the country is known for good food / good restaurants',
        icon: 'las la-star'
      },
      { name: 'Exciting cities to visit', icon: 'las la-fire-alt' },
      {
        name: 'That the country is visited by many tourists',
        icon: 'las la-users'
      },
      {
        name: 'Price level in the country (affordability)',
        icon: 'las la-hand-holding-usd'
      },
      {
        name: 'Environmental concerns and sustainability',
        icon: 'las la-leaf'
      },
      { name: 'Safety standards/low crime levels', icon: 'las la-shield-alt' },
      { name: 'Child friendliness', icon: 'las la-baby-carriage' },
      { name: 'Cleanliness', icon: 'las la-broom' },
      { name: 'Shopping', icon: 'las la-shopping-bag' },
      { name: 'Nature/outdoor experiences', icon: 'las la-mountain' },
      {
        name: 'Cultural experiences (museums, concerts, theaters)',
        icon: 'las la-theater-masks'
      },
      { name: 'Historical experiences', icon: 'las la-landmark' },
      { name: 'Going to the beach', icon: 'las la-umbrella-beach' },
      {
        name: 'Gaining a new skill/developing skill, e.g. language, cooking or similar',
        icon: 'las la-sign-language'
      },
      { name: 'Wellness/Spa', icon: 'las la-spa' },
      {
        name: 'Exciting food experience opportunities',
        icon: 'las la-utensils'
      },
      { name: 'Food experiences', icon: 'las la-utensils' },
      { name: 'Fine dining', icon: 'las la-concierge-bell' },
      {
        name: 'That the destination has few tourists',
        icon: 'las la-user-alt-slash'
      },
      {
        name: 'Opportunities for going to theme- or amusement parks',
        icon: 'las la-laugh-beam'
      },
      { name: 'Being active', icon: 'las la-running' },
      { name: 'Guided/Arranged tours/experiences', icon: 'las la-users' },
      { name: 'Big city experiences', icon: 'las la-city' },
      { name: 'Getting new experiences', icon: 'las la-fire-alt' },
      { name: 'Meeting new people', icon: 'las la-user-friends' },
      { name: 'Interacting with locals', icon: 'las la-language' },
      {
        name: 'Easy access to health and medical facilities',
        icon: 'las la-ambulance'
      },
      { name: 'Accessibility for less mobile', icon: 'las la-wheelchair' },
      { name: 'LGBTQ+-friendly', icon: 'las la-mercury' },
      { name: 'LGBTQ+- friendliness', icon: 'las la-mercury' },
      {
        name: 'Climate compensated/Low carbon emission hotel, flight, bus, train, ect.',
        icon: 'las la-smog'
      },
      { name: 'All inclusive accommodation options', icon: 'las la-wallet' },
      { name: 'Direct flight', icon: 'las la-plane' },
      { name: 'Flights from local airport', icon: 'las la-plane-departure' },
      {
        name: 'Being able to drive to the destination yourself',
        icon: 'las la-truck-pickup'
      },
      { name: 'Being active (Sport, adventure)', icon: 'las la-running' },
      { name: 'Nightlife', icon: 'las la-glass-cheers' },
      { name: 'Photography', icon: 'las la-camera' },
      { name: 'Minimizing my carbon footprint', icon: 'las la-smog' },
      {
        name: 'Opportunities for going to theme parks',
        icon: 'las la-laugh-beam'
      },
      { name: 'Living new experiences', icon: 'las la-fire-alt' },
      {
        name: 'Being able to drive to the destination',
        icon: 'las la-truck-pickup'
      },
      {
        name: 'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
        icon: 'las la-wallet'
      },
      { name: 'Flights from my local airport', icon: 'las la-plane-departure' },
      { name: 'Health and hygiene standards', icon: 'las la-notes-medical' },
      { name: 'Pet friendly', icon: 'las la-dog' },
      { name: 'Pet friendliness', icon: 'las la-dog' },
      {
        name: 'Cultural & Historical Experiences (Museums, cultural & historical sites)',
        icon: 'las la-landmark'
      },
      {
        name: 'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
        icon: 'las la-basketball-ball'
      },
      {
        name: 'Agenda of Festivals, Concerts & Events',
        icon: 'las la-theater-masks'
      },
      { name: 'Backpacker friendliness', icon: 'las la-hiking' },
      {
        name: 'Environmental concerns and sustainability (travel activity impact/carbon footprint/etc.)',
        icon: 'las la-leaf'
      },
      {
        name: 'General cleanliness (garbage management standards)',
        icon: 'las la-broom'
      },

      {
        name: 'Discovering the destination though guided or arranged tours/experiences',
        icon: 'las la-users'
      },
      {
        name: 'Living new experiences (getting out of the confort zone)',
        icon: 'las la-fire-alt'
      },
      {
        name: 'Opportunity for meeting new people',
        icon: 'las la-user-friends'
      },
      {
        name: 'Easy access to medical facilities (infrastructure, availability, proximity).',
        icon: 'las la-ambulance'
      },
      {
        name: 'Accessibility for travellers with less mobility',
        icon: 'las la-ambulance'
      },
      {
        name: 'Health and hygiene standards associated to local / global outbreaks',
        icon: 'las la-notes-medical'
      },
      {
        name: 'Opportunity to pursue travel / artistic photography',
        icon: 'las la-camera'
      },
      {
        name: 'Availability of luxury and VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
        icon: 'las la-money-bill'
      },
      {
        name: 'Possibility of a spiritual experience, pilgrimage or practice religion',
        icon: 'las la-praying-hands'
      },
      {
        name: 'The possibility to practice a specific preferred activity as ski, diving, surf, kitesurf, golf, etc.',
        icon: 'las la-skiing'
      },
      {
        name: 'Opportunities to make social media content',
        icon: 'las la-hashtag'
      },
      { name: 'Premium/luxury accommodation options', icon: 'las la-wallet' },
      { name: 'Going to the mountain and wilderness', icon: 'las la-mountain' },
      { name: 'Visiting small and unique towns', icon: 'las la-igloo' },
      { name: 'Political instability in destination', icon: 'las la-city' },
      { name: 'Political instability in my country', icon: 'las la-landmark' },
      { name: 'Threat of terrorist attack', icon: 'las la-shield-alt' },
      {
        name: 'Global health concerns (covid, monkey pox)',
        icon: 'las la-heart'
      },
      { name: 'International conflicts', icon: 'las la-exclamation-triangle' },
      {
        name: 'Inconvenience in airports (delays/cancellations)',
        icon: 'las la-plane-arrival'
      },
      { name: 'Increase of cost of holidays', icon: 'las la-umbrella-beach' },
      {
        name: 'Cost of living increase affecting disposable income',
        icon: 'las la-money-bill'
      },
      {
        name: 'Natural disasters or extreme weather at the destination',
        icon: 'las la-snowflake'
      }
    ],
    barriersIcons: [
      {
        label: 'Political instability in destination',
        value: 1617,
        icon: 'fmd_bad'
      },
      {
        label: 'Political instability in my country',
        value: 1618,
        icon: 'my_location'
      },
      {
        label: 'Threat of terrorist attack',
        value: 1619,
        icon: 'crisis_alert'
      },
      {
        label: 'Global health concerns (covid, monkey pox)',
        value: 1620,
        icon: 'coronavirus'
      },
      {
        label: 'International conflicts',
        value: 1621,
        icon: 'public_off'
      },
      {
        label: 'Inconvenience in airports (delays/cancellations)',
        value: 1622,
        icon: 'airplanemode_inactive'
      },
      {
        label: 'Increase of cost of holidays',
        value: 1623,
        icon: 'add_card'
      },
      {
        label: 'Cost of living increase affecting disposable income',
        value: 1624,
        icon: 'account_balance'
      },
      {
        label: 'Natural disasters or extreme weather at the destination',
        value: 1625,
        icon: 'thunderstorm'
      }
    ],
    barriers: [
      {
        label: 'Political instability in destination',
        value: 1617
      },
      {
        label: 'Political instability in my country',
        value: 1618
      },
      {
        label: 'Threat of terrorist attack',
        value: 1619
      },
      {
        label: 'Global health concerns (covid, monkey pox)',
        value: 1620
      },
      {
        label: 'International conflicts',
        value: 1621
      },
      {
        label: 'Inconvenience in airports (delays/cancellations)',
        value: 1622
      },
      {
        label: 'Increase of cost of holidays',
        value: 1623
      },
      {
        label: 'Cost of living increase affecting disposable income',
        value: 1624
      },
      {
        label: 'Natural disasters or extreme weather at the destination',
        value: 1625
      }
    ]
  };
}
